import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

export const loadStores: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { storeApi },
) =>
  action$.pipe(
    ofType(actions.CITY_STORES_ACTIONS.REQUESTED),
    switchMap(({ payload: { cityId } }) =>
      storeApi.getStoresByCityId(cityId).pipe(
        switchMap(({ stores, city }) =>
          of(actions.storesSucceeded(stores, city)),
        ),
        catchError(error => of(actions.storesFailed(error))),
      ),
    ),
  );



// WEBPACK FOOTER //
// ./src/scenes/CityStores/services/epics/loadStores.ts